var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatRefreshIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1085 7.66602L17.5071 8.4112C17.7767 8.91499 17.9114 9.16689 17.8223 9.27477C17.7332 9.38265 17.4397 9.29552 16.8528 9.12127C16.266 8.94705 15.643 8.85332 14.9974 8.85332C11.4996 8.85332 8.66406 11.605 8.66406 14.9994C8.66406 16.1188 8.97248 17.1684 9.51135 18.0724M12.8863 22.3327L12.4876 21.5875C12.2181 21.0837 12.0834 20.8318 12.1725 20.7239C12.2616 20.616 12.5551 20.7032 13.142 20.8774C13.7288 21.0516 14.3518 21.1454 14.9974 21.1454C18.4952 21.1454 21.3307 18.3937 21.3307 14.9994C21.3307 13.8799 21.0223 12.8303 20.4835 11.9263",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRefreshIcon);
export default __webpack_public_path__ + "static/media/chat-refresh-icon.c5043c465e7fd6e125cf062f2e3fbd7f.svg";
export { ForwardRef as ReactComponent };